import { render } from "./VMap.vue?vue&type=template&id=fea2835c"
import script from "./VMap.vue?vue&type=script&lang=ts"
export * from "./VMap.vue?vue&type=script&lang=ts"

import "./VMap.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script